<template>
  <el-dialog
    title="Створити оголошення"
    :visible="visible"
    width="800px"
    @close="handleClose"
    @open="onOpen"
  >
    <el-form
      ref="form"
      label-width="200px"
      :model="formData"
      :rules="rules"
    >
      <el-form-item label="Назва:" prop="name">
        <el-input
          v-model="formData.name"
          placeholder="Назва оголошення"
        />
        {{ $_ErrorMixin_getError('phone') }}
      </el-form-item>
      <el-form-item label="Опис:" prop="text">
        <Redactor
          v-model="formData.text"
          class="editable-text__editor"
        />
      </el-form-item>
      <el-form-item label="Технічні характеристики:" prop="characteristic">
        <el-input
          v-model="formData.characteristic"
          placeholder="Технічні характеристики"
          :rows="5"
          type="textarea"
        />
      </el-form-item>
      <el-form-item label="Ціна:" prop="price">
        <el-input
          v-model="formData.price"
          :disabled="formData.is_negotiable"
          placeholder="Ціна"
        />
      </el-form-item>
      <el-form-item label="Ціна від:">
        <el-switch
          v-model="formData.is_price_from"
          :disabled="formData.is_negotiable"
        />
      </el-form-item>
      <el-form-item label="Ціна договірна:">
        <el-switch v-model="formData.is_negotiable" />
      </el-form-item>
      <el-form-item label="Валюта:" prop="currency">
        <el-select
          v-model="formData.currency"
          :disabled="formData.is_negotiable"
        >
          <el-option label="UAH" value="1" />
          <el-option label="USD" value="2" />
          <el-option label="EUR" value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="Категорія:" prop="category_id">
        <CategorySelector
          v-model="categorySelector"
          placeholder="Оберіть категорію"
        />
      </el-form-item>
      <el-form-item label="Зображення:">
        <ImagesEdit
          edit-mode
          :images="images"
          @status-change="handleImagesStatusChange"
        />
      </el-form-item>
      <el-form-item label="Відео:" prop="video">
        <el-input
          v-model="formData.video"
          placeholder="Посилання на відео"
          type="text"
        />
      </el-form-item>
      <el-form-item label="Місцезнаходження" prop="city_id">
        <el-select
          v-if="cityOptions"
          v-model="formData.city_id"
          filterable
          placeholder="Город"
          remote
          :remote-method="getCity"
          reserve-keyword
        >
          <el-option
            v-for="item in cityOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Номер телефону:" prop="contacts.phone">
        <el-input
          v-model="formData.contacts.phone"
          placeholder="Номер телефону"
          type="text"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">Скасувати</el-button>
      <el-button type="primary" @click="save">Зберегти</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {mapActions} from 'vuex';
import ErrorMixin from '../../utils/ErrorMixin';
import CategorySelector from '@/components/wishes/CategorySelector.vue';
import ImagesEdit from '@/components/common/ImagesEdit.vue';
import Redactor from '@/components/common/WysiwygRedactor.vue'

export default {
  name: 'CreateProductModal',
  components: { Redactor, ImagesEdit, CategorySelector},
  mixins: [ErrorMixin],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const phoneRegex = /^\+?[0-9]{10,13}$/;
      if (!value) {
        callback(new Error('Будь ласка, введіть номер телефону'));
      } else if (!phoneRegex.test(value.replace(/\s/g, ''))) {
        callback(new Error('Неправильний формат номеру телефону'));
      } else {
        callback();
      }
    };

    const validateVideo = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;
      if (!youtubeRegex.test(value)) {
        callback(new Error('Будь ласка, введіть правильне посилання на YouTube'));
      } else {
        callback();
      }
    };
    return {
      formData: {
        name: '',
        text: '',
        characteristic: '',
        price: '',
        category_id: '',
        currency: '1',
        images: [],
        video: '',
        city_id: '',
        contacts: {phone: ''},
        is_price_from: false,
        is_negotiable: false,
      },
      rules: {
        name: [
          { required: true, message: 'Будь ласка, введіть назву', trigger: 'blur' },
          { min: 3, max: 255, message: 'Довжина повинна бути від 3 до 255 символів', trigger: 'blur' },
        ],
        text: [
          { required: true, message: 'Будь ласка, введіть опис', trigger: 'blur' },
          { min: 10, max: 4000, message: 'Довжина повинна бути від 10 до 4000 символів', trigger: 'blur' },
        ],
        characteristic: [
          { min: 20, max: 4000, message: 'Довжина повинна бути від 20 до 4000 символів', trigger: 'blur' },
        ],
        price: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.is_negotiable) {
                callback();
                return;
              }
              if (!value && value !== 0) {
                callback(new Error('Будь ласка, введіть ціну'));
              } else if (isNaN(Number(value)) || Number(value) < 0) {
                callback(new Error('Ціна повинна бути позитивним числом'));
              } else if (Number(value) > 10000000) {
                callback(new Error('Ціна не повинна перевищувати 10 000 000'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        currency: [
          { required: true, message: 'Будь ласка, виберіть валюту', trigger: 'change' },
        ],
        city_id: [
          { required: true, message: 'Будь ласка, виберіть місто', trigger: 'change' },
        ],
        'contacts.phone': [
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],
        video: [
          { validator: validateVideo, trigger: 'blur' },
        ],
        category_id: [
          { required: true, message: 'Будь ласка, виберіть категорію', trigger: 'change' },
        ],
      },
      images: [],
      cityOptions: [],
      categories: [],
    };
  },
  computed: {
    categorySelector: {
      get() {
        return this.formData.category_id;
      },
      set(newValue) {
        if (Array.isArray(newValue) && newValue.length > 0) {
          this.formData.category_id = newValue[newValue.length - 1];
        } else {
          this.formData.category_id = newValue;
        }
      },
    },
  },
  watch: {
    'formData.is_negotiable'(newVal) {
      if (newVal) {
        this.formData.price = '';
        this.formData.is_price_from = false;
      }
    },
  },
  methods: {
    ...mapActions('cities', [
      'fetchCities','preloadCities',
    ]),
    ...mapActions('wishes/categories', ['fetchCategories']),
    ...mapActions('users', ['saveProduct']),

    async onOpen() {
      await this.getCities()
      await this.getCategories()
    },
    handleClose() {
      this.$emit('closeModal');
    },
    cancel() {
      this.$emit('closeModal');
    },
    async save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const formDataToSubmit = {...this.formData};
          formDataToSubmit.images = this.images.map(img => img.id);
          this.saveProduct({userId: this.userId, data: formDataToSubmit}).then((rsp) => {
            if (rsp.success) {
              this.$message({
                message: 'Оголошення успішно створено',
                type: 'success',
              });
              this.handleClose()
            } else {
              this.$message.error(rsp.message || 'Помилка при створенні оголошення')
              console.error('message: ', rsp.message)
            }
          })
            .catch((error) => {
              console.error('Error:', error);
              this.$message.error('Сталася помилка при збереженні');
            });
        } else {
          this.$message.error('Будь ласка, виправте помилки у формі');
          return false;
        }
      })
    },
    async getCities() {
      this.cityOptions = await this.preloadCities()
    },
    async getCity(query) {
      if (query !== '') {
        this.cityOptions = await this.fetchCities({ search: query });
      }
    },
    async getCategories() {
      this.categories = await this.fetchCategories()
    },
    handleImagesStatusChange({ isEdited, images }) {
      if (isEdited) {
        this.images = images;
      }
    },
  },
};
</script>

<!--<style scoped>-->
<!--.dialog-footer {-->
<!--  display: flex;-->
<!--  justify-content: flex-end;-->
<!--}-->
<!--</style>-->


